import React from "react";
import { observer } from "mobx-react-lite";
import { Div, ModalBackground } from "@icecreamsocial/components";
import styled, { css, keyframes } from "styled-components";

const wipeIn = keyframes`
	0% {
		transform: scaleX(0) scaleY(0);
	}
	33% {
		transform: scaleX(100%) scaleY(1%)
	}
	100% {
		transform: scaleX(100%) scaleY(100%);
	}
`;

const AnimatedModalBackground = styled(ModalBackground)`
  ${({ open, duration }) =>
    open &&
    css`
      animation: ${wipeIn} ${duration}ms ease-in-out;
    `};
`;

const Transition = styled(Div)`
  ${({ duration, delay, flavor, open }) => css`
    opacity: 0;
    transform: scale(0);
		transition: opacity ${duration}ms linear,
			transform ${duration}ms cubic-bezier(0.165, 0.84, 0.44, 1);

    ${open &&
      css`
        opacity: 1;
        transform: scale(1);
      `}

    ${flavor === "modal" &&
      css`
        ${open &&
          css`
            transition: opacity ${duration}ms linear ${delay}ms,
              transform ${duration}ms cubic-bezier(0.165, 0.84, 0.44, 1)
                ${delay}ms;
          `}
      `}
		
		${flavor === "callout" &&
      css`
        transform-origin: bottom right;
      `}
  `};
`;

/**
 * @description
 * Handles the transition of the layout
 */
export const FlavorAnimator = observer(
  ({ open = false, flavor, duration, delay, ...rest }) => (
    <>
      {flavor === "modal" && (
        <AnimatedModalBackground open={open} duration={duration} zIndex="0" />
      )}
      <Transition
        open={open}
        duration={duration / 2}
        delay={delay}
        flavor={flavor}
        {...rest}
      />
    </>
  )
);
